var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { DotsVerticalIcon, IconButton, translate, } from '@lucidlink/uicore';
export const MenuTrigger = ({ className, isFloatingBoxActive: _isFloatingBoxActive, testId, ...triggerProps }) => {
    return (_jsx(IconButton, { ...triggerProps, "aria-label": translate('workspace menu toggle'), className: className, "data-testid": `workspace-menu-trigger-${testId ?? ''}`, Icon: DotsVerticalIcon, kind: "ghost", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            triggerProps.onClick(e);
        }, onKeyDown: (e) => {
            e.stopPropagation();
            triggerProps.onKeyDown(e);
        }, size: "medium" }));
};
_react_refresh_temp_1 = MenuTrigger;
$RefreshReg$(_react_refresh_temp_1, "MenuTrigger");
